import { AiChatPanel } from '@/components/ai-chat';

/**
 * AI 对话 / 生图组件测试页
 * 访问路径：/test-ai
 */
export default function TestAiPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <AiChatPanel channel="test-ai" className="min-h-0 flex-1" />
    </div>
  );
}
